export const COURSEWAREITEM = 'coursewareItem';
export const COMPONENTS = 'components';
